import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.switch` (toggle). Knob is a real child (not ::after)
// so its position can be driven by the `on` state in StyleX.
export const styles = {
  track: {
    kVAEAm: "x1n2onr6",
    k1xSpc: "x1rg5ohu",
    kzqmXN: "x10h3iyq",
    kZKoxP: "xxk0z11",
    kmuXW: "x2lah0s",
    kmVPX3: "x1717udv",
    kaIpWk: "xoy5co8",
    kWkggS: "xv573ff",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1ujv9i6",
    $$css: true
  },
  trackOn: {
    kWkggS: "xlvhwkj",
    kVAM5u: "xa126vr",
    $$css: true
  },
  knob: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xs7f9wi",
    kbCHJM: "x54rlcq",
    kzqmXN: "x1xp8n7a",
    kZKoxP: "xmix8c7",
    kaIpWk: "xoy5co8",
    kWkggS: "x1c1bete",
    kmkexE: "x47uq8k",
    $$css: true
  },
  knobOn: {
    kbCHJM: "x1c42kn3",
    kWkggS: "xs02ony",
    $$css: true
  },
  disabled: {
    kSiTet: "xbyyjgo",
    kkrTdU: "x1h6gzvc",
    $$css: true
  }
};